import { render, staticRenderFns } from "./CeldaPickcolor.vue?vue&type=template&id=2276a36d&scoped=true"
import script from "./CeldaPickcolor.vue?vue&type=script&lang=js"
export * from "./CeldaPickcolor.vue?vue&type=script&lang=js"
import style0 from "./CeldaPickcolor.vue?vue&type=style&index=0&id=2276a36d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2276a36d",
  null
  
)

export default component.exports